import React from 'react'
import Layout, { Container } from '../components/layout'

const TicketManage = () => {
  return (
<Layout>
    <Container>
    <div className="">
          <section className="px-4 py-4">
            <div className="flex px-2 py-2 shadow mb-1">
              <div className="svg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.56994 18.8201C9.37994 18.8201 9.18994 18.7501 9.03994 18.6001L2.96994 12.5301C2.67994 12.2401 2.67994 11.7601 2.96994 11.4701L9.03994 5.40012C9.32994 5.11012 9.80994 5.11012 10.0999 5.40012C10.3899 5.69012 10.3899 6.17012 10.0999 6.46012L4.55994 12.0001L10.0999 17.5401C10.3899 17.8301 10.3899 18.3101 10.0999 18.6001C9.95994 18.7501 9.75994 18.8201 9.56994 18.8201Z"
                    fill="#061B2E"
                  />
                  <path
                    d="M20.4999 12.7501H3.66994C3.25994 12.7501 2.91994 12.4101 2.91994 12.0001C2.91994 11.5901 3.25994 11.2501 3.66994 11.2501H20.4999C20.9099 11.2501 21.2499 11.5901 21.2499 12.0001C21.2499 12.4101 20.9099 12.7501 20.4999 12.7501Z"
                    fill="#061B2E"
                  />
                </svg>
              </div>
              <p className="px-1 text-sm font-bold text-black">
                Ticket Details
              </p>
            </div>
            <div className="flex ">
              <div className="px-2 bg-stone-100 sm:w-full lg:w-9/12  ">
                <div className="grid grid-cols-2 gap-2 gap-x-0.5 px-4  sm:px-0 lg:mt-16 sm:grid-cols-2 lg:grid-cols-3 xl:gap-2">
                  <div className="flex flex-col items-start max-w-4xl ">
                    <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                      User
                    </h4>
                    <p className="px-2 py-0 text-sm text-black font-bold">
                      Brentrodriguez
                    </p>
                  </div>
                  <div className="flex flex-col items-start max-w-4xl">
                    <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                      Phone Number
                    </h4>
                    <p className="px-2 py-0 text-sm text-black font-bold">
                      999-999-999
                    </p>
                  </div>
                  <div className="flex flex-col items-start max-w-4xl">
                    <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                      Status
                    </h4>
                    <p className="px-2 py-0 text-sm text-black font-bold">
                      In Progress
                    </p>
                  </div>
                  <div className="flex flex-col items-start max-w-4xl">
                    <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                      Subject
                    </h4>
                    <p className="px-2 py-0 text-sm text-black font-bold">
                      Password reset not working
                    </p>
                  </div>
                  <div className="flex flex-col items-start max-w-4xl">
                    <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                      Submitted
                    </h4>
                    <p className="px-2 py-0 text-sm text-black font-bold">
                      Nov 14, 2021 08:00
                    </p>
                  </div>
                  <div className="flex flex-col items-start max-w-4xl ">
                    <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                      Ticket ID
                    </h4>
                    <p className="px-2 py-0 text-sm text-black font-bold">
                      1234515
                    </p>
                  </div>
                </div>
                <div className="px-4 py-4">
                  <div className="border rounded-lg bg-white py-2">
                    <p className="py-2 px-2 text-gray-400 text-sm text-start">
                      Ticket Issue
                    </p>
                    <p className="py-1 px-2 text-black text-sm text-start">
                      Hi, I can’t seem to update the app. It says “Error
                      checking updates” when I tried to update the app via
                      Google Play. Pls help.
                    </p>
                    <img
                      class="flex justify-start ml-2 px-2 py-2 mt-6 w-20 h-auto border-gray border"
                      src="https://storage.googleapis.com/proudcity/mebanenc/uploads/2021/03/placeholder-image-768x576.png"
                      alt="..."
                    ></img>
                  </div>
                </div>
                <div className="px-4 py-4">
                  <p className="px-2 py-3 my-4 bg-gray-200 text-black text-sm font-medium text-center w-fit m-auto rounded-lg">
                    Choose an assignee and set status to “In Progress” to add
                    response.
                  </p>
                  <p className="px-2 py-3 my-4 bg-gray-200 text-black text-sm font-medium text-center w-fit m-auto rounded-lg">
                    This ticket has been solved.
                  </p>
                  <p className="px-2 py-3 my-4 bg-gray-200 text-black text-sm font-medium text-center w-fit m-auto rounded-lg">
                    This ticket is deferred.
                  </p>
                  <p className="px-4 py-3 my-2 bg-teal-500 text-white text-sm font-medium text-center w-fit m-auto rounded-full">
                    Add Response
                  </p>
                </div>
                <div className="px-4 py-4">
                  <div className="border rounded-lg bg-green-100 py-2">
                    <div className="flex px-0 py-0 pb-4 items-center justify-start">
                      <div className="px-2">
                        <svg
                          width="44"
                          height="44"
                          viewBox="0 0 44 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_3308_397)">
                            <rect
                              width="44"
                              height="44"
                              rx="12"
                              fill="#EBF9F5"
                            />
                            <path
                              d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                              fill="#45C49C"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_3308_397">
                              <rect
                                width="44"
                                height="44"
                                rx="12"
                                fill="white"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <p className="text-sm text-black font-medium px-2">
                        Deanna Jones
                      </p>
                    </div>
                    <p className="py-1 px-2 text-black text-sm text-start">
                      Have you tried turning your phone off and on again?
                    </p>
                    <img
                      class="bg-gray-200 flex justify-start ml-2 px-2 py-2 mt-6 w-20 h-auto border-gray border"
                      src="https://storage.googleapis.com/proudcity/mebanenc/uploads/2021/03/placeholder-image-768x576.png"
                      alt="..."
                    ></img>
                    <p className="px-2 py-2 text-end text-black text-sm">
                      20.00
                    </p>
                  </div>
                </div>
                <div className="px-4 py-4">
                  <div className="border rounded-lg bg-white py-2">
                    <p className="py-2 px-2 text-black text-sm text-start font-bold">
                      Govlog
                    </p>
                    <p className="py-1 px-2 text-black text-sm text-start">
                      This is user message.
                    </p>
                    <img
                      class="flex justify-start ml-2 px-2 py-2 mt-6 w-20 h-auto border-gray border"
                      src="https://storage.googleapis.com/proudcity/mebanenc/uploads/2021/03/placeholder-image-768x576.png"
                      alt="..."
                    ></img>
                    <p className="px-2 py-2 text-end text-black text-sm">
                      20.00
                    </p>
                  </div>
                </div>
              </div>
              <div className="px-2 bg-white  sm:w-full lg:w-1/3">
                <p className="px-4 py-8 text-sm text-black font-bold text-start">
                  Assignee
                </p>
                <div className="mt-5 flex items-center justify-start pb-2">
                  <div className="ml-2 svg">
                    <svg
                      width="44"
                      height="44"
                      viewBox="0 0 44 44"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_3308_397)">
                        <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                        <path
                          d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                          fill="#45C49C"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3308_397">
                          <rect width="44" height="44" rx="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>{" "}
                  </div>

                  <p className=" ml-4 text-sm text-black font-bold">
                    Brent Rodriguez
                  </p>
                </div>

                <div className="mt-5 py-3">
                  <p className="px-3 py-2 border rounded-full text-black font-normal  text-sm">
                    Choose Assignee
                  </p>
                </div>

                <div className="mt-5 py-3">
                  <h4 className="px-3 py-2 text-lg font-bold text-black text-start">
                    Status
                  </h4>
                  <p className="px-3 py-2 border rounded-full text-black font-normal text-sm">
                    Select status
                  </p>
                </div>

                <div className="mt-5 py-3">
                  <h4 className="px-3 py-2 text-lg font-bold text-black text-start">
                    Priority
                  </h4>
                  <p className="px-3 py-2 border rounded-full text-black font-normal  text-sm">
                    Select Priority
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
    </Container>
</Layout>
  )
}

export default TicketManage